<template>
  <tr class="row-details">
    <td class="v-align-middle"  colspan="6" v-if="readyToRender">
      <div class="cu-container">
        <customer 
          :customer="customer" 
          :is-details="isDetails"
        ></customer>

        <customer 
          :customer="validationRequestable" 
          :is-details="isDetails"
        ></customer>
      </div>
    </td>
  </tr>
</template>

<script>
import { apiV2 } from 'store/api'
import Customer from "./ValidationRequestable/CustomerV2"

export default {
  name:"CustomerUpdate",

  props:["validationRequestId", "isDetails"],

  components:{
    Customer
  },

  data() {
    return {
      validationRequest: null
    }
  },

  computed: {
    readyToRender() {
      return this.validationRequest != null
    },

    customer() {
      return this.validationRequest.included.customer
    },

    validationRequestable() {
      return this.validationRequest.included.validation_requestable
    }
  },

  created() {
    const params = {
      with: 'customer,validation_requestable'
    }

    apiV2.getValidationRequest(this.validationRequestId, params)
      .then((response) => this.validationRequest = response.data.data)
  }
}
</script>

<style scoped>
.cu-container {
  display: inline-flex;
  width: 100%;
}
.cu-container > div { margin-right: 15px; }
.cu-container > div:last-child { margin-right: 0; }

.row-details td {
  background-color: #e0e0e0
}
</style>



// WEBPACK FOOTER //
// client/components/Demands/Details/CustomerUpdate.vue